import React, { useState, useEffect } from 'react'
import FormActionButtons from '../../../../Shared/FormAction/FormActionButtons'
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Form, Schema } from 'rsuite';
import Information from '../../../../Shared/Card/Information';
import { GetAppInformationContent } from '../../../../Shared/InformationContent/PeInformation';
import EmploymentLicensure from '../../../../Shared/Card/EmploymentLicensure';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import LoadingSpinner from '../../../../Shared/GenericComponents/LoadingSpinner';
import publicApplicationService from '../../../../../services/Internal/Application/PE/peApplication.service';
import applicationService from '../../../../../services/Internal/Application/application.service';
import FormEntityInformation from '../../../Shared/FormEntityInformation';
import employmentService from '../../../../../services/Internal/Application/PE/employment.service';
import { getEfCredential } from '../../../../../services/Shared/codeTable.service';
import Issues from '../../../../Shared/Card/Issues';
import entityService from '../../../../../services/Internal/Staff/entity.service';

function EmploymentPage() {
    const [sectionData, setSectionData] = useState({});
    const [hasLoaded, setHasLoaded] = useState(false);
    const push = useNavigate();
    const { StringType, ObjectType } = Schema.Types;
    const [option, setOption] = useState();
    const sectionId = 5;
    const routes = useSelector(x => x.currentRoutes);
    const appTypeId = useSelector(x => x.currentApplicationTypeId);
    const appType = appTypeId == 3 ? "By Comity" : appTypeId == 4 ? "By Exam" : "";
    const store = useSelector(x => x);
    const [isComplete, setIsComplete] = useState(false);
    const [isUserEditable, setIsUserEditable] = useState(true);
    const [entityInfo, setEntityInfo] = useState(
        {
            lolaNum: null,
            entityName: '',
            licenseNumber: '',
            formType: "Professional Engineer Application " + appType,
            isIndividual: true,
            entityId: 0,
            applicationDate: "",
            currentSection: "Employment"
        }
    );
    const [formModel, setFormModel] = useState({
        id: 0,
        applicationId: store.currentApplicationId,
        employedBy: '',
        licensedFirmType: '',
        firmNumber: null,
        comment: '',
        signature: ''
    })
   
    useEffect(() => {
        setHasLoaded(false);
        employmentService.getEmployment(store.currentApplicationId).then((response) => {
            publicApplicationService.peGetSection(store.currentApplicationId, sectionId).then((data) => {
                setSectionData(data.data);
                if (response.data) {
                    var licensedFirmType = "";
                    if (response.data.firmIsLicensed)
                        licensedFirmType = "licensed";
                    else if (response.data.firmIsNotLicensed)
                        licensedFirmType = "unlicensed";
                    else if (response.data.soleProprietor)
                        licensedFirmType = "soleProprietor";
                    else if (response.data.unemployed)
                        licensedFirmType = "unemployed"
                    if (response.data.credentialId) {
                        getEfCredential(response.data.credentialId).then((cred) => {
                            setFormModel({
                                id: response.data.id,
                                employedBy: response.data.employedByName,
                                firmNumber: cred?.value,
                                comment: response.data.comment,
                                licensedFirmType: licensedFirmType,
                                signature: data.data.electronicSignature
                            });
                            setOption(licensedFirmType);
                        })
                    }
                    else {
                        setFormModel({
                            id: response.data.id,
                            employedBy: response.data.employedByName,
                            firmNumber: response.data.credentialId,
                            comment: response.data.comment,
                            licensedFirmType: licensedFirmType,
                            signature: data.data.electronicSignature
                        });
                        setOption(licensedFirmType);
                    }
                }
                setIsComplete(data.data.staffReviewComplete)
                applicationService.getIndividualApplication(store.currentApplicationId).then((appData) => {
                    setIsUserEditable(appData.data.status.id == 2)
                    entityService.getEntity(data.data.entityId).then((entity) => {
                        setEntityInfo(
                            {
                                ...entityInfo,
                                lolaNum: entity.data.lolaNumber,
                                entityName: entity.data.formattedName,
                                entityId: entity.data.entityId,
                                licenseNumber: appData.data?.credential?.formattedLicenseNumber,
                                applicationDate: appData.data?.dateSubmitted
                            })
                        setHasLoaded(true);
                    });
                });
            })
        })

    }, [])
    const model = Schema.Model({
        licensedFirmType: StringType().isRequired('This field is required'),
        comment: StringType().when(schema => {
            const { value } = schema.licensedFirmType;
            return value === 'soleProprietor' ? StringType().isRequired('This field is required.') : StringType();
        }),
        firmNumber: ObjectType().when(schema => {
            const { value } = schema.licensedFirmType;
            return value === 'licensed' ? ObjectType().isRequired('This field is required.') : ObjectType();
        }),
        employedBy: StringType().when(schema => {
            const { value } = schema.licensedFirmType;
            return value === 'unlicensed' ? StringType().isRequired('This field is required.') : StringType();
        })
    });

    const formSubmit = (validation, event) => {
        var hasErrors = false;
        var validationObject = model.check(formModel);
        for (const key in validationObject) {
            if (validationObject[key].hasError) {
                if (key === "firmNumber" && formModel.licensedFirmType === "licensed") {
                    hasErrors = true;
                    return
                }
                else if (key === "employedBy" && formModel.licensedFirmType === "unlicensed") {
                    hasErrors = true;
                    return
                }
                else if (key === "comment" && formModel.licensedFirmType === "soleProprietor") {
                    hasErrors = true;
                    return
                }
                else if (key === "licensedFirmType") {
                    hasErrors = true;
                    return
                }
            }
        }
        if (!hasErrors) {
            submitData();
        }

    }
    const clearFirmNumber = () => {
        setFormModel({ ...formModel, firmNumber: null });
    }
    const submitData = () => {
        var dataTransfer = {
            id: formModel.id,
            applicationId: store.currentApplicationId,
            comment: formModel.comment,
            credentialId: formModel.firmNumber ? formModel.firmNumber.licenseNumber : null,
            employedByName: formModel.employedBy,
            entityId: store.userInfo.EntityId,
            firmIsLicensed: formModel.licensedFirmType ? formModel.licensedFirmType == "licensed" ? true : false : null,
            firmIsNotLicensed: formModel.licensedFirmType ? formModel.licensedFirmType == "unlicensed" ? true : false : null,
            soleProprietor: formModel.licensedFirmType ? formModel.licensedFirmType == "soleProprietor" ? true : false : null,
            unemployed: formModel.licensedFirmType ? formModel.licensedFirmType == "unemployed" ? true : false : null
        };
        employmentService.postEmployment(dataTransfer).then((response) => {
            publicApplicationService.pePostSection(store.currentApplicationId, sectionId, formModel.signature).then((data) => {
                publicApplicationService.peMarkSectionComplete(store.currentApplicationId, sectionId, isComplete).then((info) => {
                    if (response.data) {
                        nextSectionNavigation();
                    }
                    else if (response.data) {
                        var licensedFirmType = "";
                        if (response.data.firmIsLicensed)
                            licensedFirmType = "licensed";
                        else if (response.data.firmIsNotLicensed)
                            licensedFirmType = "unlicensed";
                        else if (response.data.soleProprietor)
                            licensedFirmType = "soleProprietor";
                        else if (response.data.unemployed)
                            licensedFirmType = "unemployed"
                        if (response.data.credentialId) {
                            getEfCredential(response.data.credentialId).then((cred) => {
                                setFormModel({
                                    id: response.data.id,
                                    employedBy: response.data.employedByName,
                                    firmNumber: cred,
                                    comment: response.data.comment,
                                    licensedFirmType: licensedFirmType,
                                    signature: data.data.electronicSignature
                                });
                                setOption(licensedFirmType);
                                Swal.fire("Saved!");
                            })
                        }
                        else {
                            setFormModel({
                                id: response.data.id,
                                employedBy: response.data.employedByName,
                                firmNumber: response.data.credentialId,
                                comment: response.data.comment,
                                licensedFirmType: licensedFirmType,
                                signature: data.data.electronicSignature
                            });
                            setOption(licensedFirmType);
                            Swal.fire("Saved!");
                        }

                    }
                })
            })
        });
        //post formData to api
        //return bool didSave
    }
    const nextSectionNavigation = () => {
        push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
    }
    return (
        <div>
            <Container fluid>
                <FormEntityInformation {...entityInfo} />
                <Information content={GetAppInformationContent("employment")} />
                <br />
                {hasLoaded ?
                    <Form readOnly={!isUserEditable} fluid model={model} formValue={formModel} onChange={formModel => setFormModel(formModel)} onSubmit={formSubmit}>
                        <EmploymentLicensure
                            type={"EF"}
                            firmNumber={formModel.firmNumber}
                            licensedFirmType={formModel.licensedFirmType}
                            option={option}
                            setOption={setOption}
                            clearFirmNumber={clearFirmNumber} />
                        <br />
                        <Issues isUserEditable={isUserEditable} isInternal={true} type={1} sectionId={sectionData.id} setIsComplete={setIsComplete} />
                        <FormActionButtons
                            isReadOnly={!isUserEditable}
                            nextSectionCallback={nextSectionNavigation}
                            isUserEditable={isUserEditable}
                            showSectionComplete={true}
                            isComplete={isComplete}
                            isCompleteCallback={setIsComplete} backToSectionLink="/internal/peapp/sections" />
                    </Form> : <LoadingSpinner />
                }
            </Container>
        </div>
    );
}
export default EmploymentPage